export default __webpack_public_path__ + "a1e1accc44af97829bd739631c8677ba.svg";